/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetLowerthirdByDateQueryResponse, PntSegmentsControllerGetLowerthirdByDatePathParams, PntSegmentsControllerGetLowerthirdByDateQueryParams } from "../models/PntSegmentsControllerGetLowerthirdByDate";

export function getPntSegmentsControllerGetLowerthirdByDateUrl(slug: PntSegmentsControllerGetLowerthirdByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/lowerthird` as const }
  return res
}

/**
 * @summary Retrieve the lowerthirds for a given time range
 * {@link /pnt/v2/segments/:slug/lowerthird}
 */
export async function pntSegmentsControllerGetLowerthirdByDate(slug: PntSegmentsControllerGetLowerthirdByDatePathParams["slug"], params: PntSegmentsControllerGetLowerthirdByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntSegmentsControllerGetLowerthirdByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntSegmentsControllerGetLowerthirdByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}